<breadcrumbs [path]="breadcrumbs"></breadcrumbs>
@if (model && !model.requestType && isNewRequest) {
<add-request [slic]="navigationSlic" ></add-request>
}

@if (model && model.requestType) {
<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-11 col-lg-5 col-md-8 col-sm-10 ps-auto ps-md-0">
    @if (isNewRequest) {
<h2 class="mb-3 mt-0">{{localize(langSection.RequestFormPage, langText.New)}} {{localizeValue(langSection.RequestType, model.requestType)}}</h2>
}
    @if (!isNewRequest) {
<h2 class="mb-3 mt-0">{{localize(langSection.RequestFormPage, langText.Edit)}} {{localizeValue(langSection.RequestCategory, model.requestCategory)}} {{localizeValue(langSection.RequestType, model.requestType)}} ({{localizeValue(langSection.FilterChip, model.requestStatus)}})</h2>
}
  </div>
  <div class="col-11 ps-md-0">
    <p class="mb-3"><strong>{{localize(langSection.Term, langText.Location)}}: </strong>@if (locationProfile) {
<span>{{locationProfile.slicName}} ({{locationProfile.customName}})</span>
}</p>
  </div>
  <div class="col-11 ps-md-0">
    @if (showWeekendAlert) {
<notification
     
      [allowClose]="false"
      [title]="localize(langSection.RequestFormPage, langText.WeekendNotificationTitle)"
      [message]="localize(langSection.RequestFormPage, langText.WeekendNotificationMessage)"
    ></notification>
}
  </div>
  <div class="col-11 ps-md-0">
    @if (isNewRequest) {
<p class="mb-1">{{localize(langSection.RequestFormPage, langText.Description)}}</p>
}
    <p class="mb-3 py-0"><span>* {{localize(langSection.Term, langText.RequiredFieldNotice)}}</span></p>
  </div>
</div>
}

@if (model && model.requestType) {
<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-12 ps-md-0">
    <h5 class="mt-0">{{localize(langSection.RequestFormPage, langText.RequestWindow)}}</h5>

    <div class="row form-row ps-0 align-items-baseline">

      <div class="col-10 col-md-6 col-lg-auto form-group px-0 ms-md-0 me-2 me-md-4 request-input-date position-relative">
        <label class="fw-bold mb-0">{{localize(langSection.RequestFormPage, langText.EarliestDate)}} ({{localize(langSection.DatePicker, langText.DateFormatting)}}) *</label>
        <datepicker [date]="earliestPickupDate" [readonly]="isDisabled('earliestPickupDateTime')" [displayValidationErrors]="!submissionErrors.earliestPickupDateTime" class="{{submissionErrors.earliestPickupDateTime ? 'error' : peakSeasonWarning ? 'warning' : ''}}" (onChange)="onEarliestPickupDate($event)"></datepicker>
      </div>

      <div class="col-auto px-0">
        <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.EarliestTime)}} *</label>
        <div class="time-select {{submissionErrors.earliestPickupDateTime ? 'error' : ''}}">
          <input #earliestHours [ngModel]="earliestPickupHour" mask="00" name="earliestHour" type="text" maxlength="2" class="form-control" [readonly]="isDisabled('earliestPickupDateTime')" (input)="onEarliestPickupHour($event.target.value)" />
          <span class="px-2">:</span>
          <input #earliestMinutes [ngModel]="earliestPickupMinute" mask="00" name="earliestMinute" type="text" maxlength="2" class="form-control"  [readonly]="isDisabled('earliestPickupDateTime')" (input)="onEarliestPickupMinute($event.target.value)" />
        </div>
      </div>

      @if (is12Hour) {
<div class="col-auto px-0 ms-3 am-pm">
        <label class="fw-bold display-block mb-0">AM/PM *</label>
        <ups-select class="{{submissionErrors.earliestPickupDateTime ? 'error' : ''}}" [readonly]="isDisabled('earliestPickupDateTime')" [value]="earliestPickupAmPm" [list]="['AM', 'PM']" (change)="onEarliestPickupAmPm($event.target.value)"></ups-select>
      </div>
}
    </div>

    <div class="error-container col-10 col-md-11 ps-0 mt-0">
      @if (submissionErrors.earliestPickupDateTime || peakSeasonWarning) {
<div class="{{submissionErrors.earliestPickupDateTime ? 'text-danger' : peakSeasonWarning ? 'text-warning' : ''}}">
        {{submissionErrors.earliestPickupDateTime ? submissionErrors.earliestPickupDateTime : peakSeasonWarning ? peakSeasonWarning : ''}}
      </div>
}
    </div>

    <div class="row form-row align-items-baseline">
      <div class="col-10 col-md-6 col-lg-auto form-group px-0 ms-md-0 me-2 me-md-4 request-input-date position-relative">
        <label class="fw-bold mb-0">{{localize(langSection.RequestFormPage, langText.LatestDate)}} ({{localize(langSection.DatePicker, langText.DateFormatting)}}) *</label>
        <datepicker [date]="latestPickupDate" [readonly]="isDisabled('latestPickupDateTime')" [displayValidationErrors]="!submissionErrors.latestPickupDateTime" class="{{submissionErrors.latestPickupDateTime ? 'error' : ''}}" (onChange)="onLatestPickupDate($event)"></datepicker>
      </div>

      <div class="col-auto px-0">
        <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.LatestTime)}} *</label>
        <div class="time-select {{submissionErrors.latestPickupDateTime ? 'error' : ''}}">
          <input #latestHours [ngModel]="latestPickupHour" mask="00" name="latestHour" type="text" maxlength="2" class="form-control" [readonly]="isDisabled('latestPickupDateTime')" (input)="onLatestPickupHour($event.target.value)" />
          <span class="px-2">:</span>
          <input #latestMinutes [ngModel]="latestPickupMinute" mask="00" name="latestMinute" type="text" maxlength="2" class="form-control" [readonly]="isDisabled('latestPickupDateTime')" (input)="onLatestPickupMinute($event.target.value)" />
        </div>
      </div>

      @if (is12Hour) {
<div class="col-auto px-0 ms-3 am-pm">
        <label class="fw-bold display-block mb-0">AM/PM *</label>
        <ups-select class="{{submissionErrors.latestPickupDateTime ? 'error' : ''}}" [readonly]="isDisabled('latestPickupDateTime')" [value]="latestPickupAmPm" [list]="['AM', 'PM']" (change)="onLatestPickupAmPm($event.target.value)"></ups-select>
      </div>
}
    </div>
    <div class="error-container mt-0">
      @if (submissionErrors.latestPickupDateTime) {
<div class="text-danger">
        {{submissionErrors.latestPickupDateTime}}
      </div>
}
    </div>
  </div>
</div>
}

@if (model && model.requestType === 'Switch') {
<switch-request-form
 
  [errors]="submissionErrors"
  [model]="model"
  [isNewRequest]="isNewRequest"
  [destinations]="destinations"
  [trailerTypes]="trailerTypes"
  [sortTypes]="sortTypes"
  [serviceLevels]="serviceLevels"
  (onDestinationChange)="onDestinationChange($event)"
  (onDestinationSortChange)="onSortChange($event)"
  (fieldChange)="onFieldChange($event)">
</switch-request-form>
}
@if (model && model.requestType === 'Retrieve Load') {
<retrieve-load-request-form
  [errors]="submissionErrors"
  [model]="model"
  [isNewRequest]="isNewRequest"
  [destinations]="destinations"
  [trailerTypes]="trailerTypes"
  [sortTypes]="sortTypes"
  [serviceLevels]="serviceLevels"
  (onDestinationChange)="onDestinationChange($event)"
  (onDestinationSortChange)="onSortChange($event)"
  (fieldChange)="onFieldChange($event)">
</retrieve-load-request-form>
}
@if (model && model.requestType === 'Live Load') {
<live-load-request-form
 
  [errors]="submissionErrors"
  [model]="model"
  [isNewRequest]="isNewRequest"
  [destinations]="destinations"
  [trailerTypes]="trailerTypes"
  [sortTypes]="sortTypes"
  [serviceLevels]="serviceLevels"
  (onDestinationChange)="onDestinationChange($event)"
  (onDestinationSortChange)="onSortChange($event)"
  (fieldChange)="onFieldChange($event)">
</live-load-request-form>
}
@if (model && model.requestType === 'Request Empty') {
<request-empty-request-form
 
  [errors]="submissionErrors"
  [model]="model"
  [isNewRequest]="isNewRequest"
  [destinations]="destinations"
  [trailerTypes]="trailerTypes"
  [sortTypes]="sortTypes"
  [serviceLevels]="serviceLevels"
  (onDestinationChange)="onDestinationChange($event)"
  (onDestinationSortChange)="onSortChange($event)"
  (fieldChange)="onFieldChange($event)">
</request-empty-request-form>
}
@if (model && model.requestType === 'Retrieve Empty') {
<retrieve-empty-request-form
 
  [errors]="submissionErrors"
  [model]="model"
  [isNewRequest]="isNewRequest"
  [destinations]="destinations"
  [trailerTypes]="trailerTypes"
  [sortTypes]="sortTypes"
  [serviceLevels]="serviceLevels"
  (onDestinationChange)="onDestinationChange($event)"
  (onDestinationSortChange)="onSortChange($event)"
  (fieldChange)="onFieldChange($event)">
</retrieve-empty-request-form>
}
@if (model && model.requestType === 'REALIGN') {
<realign-request-form
 
  [errors]="submissionErrors"
  [model]="model"
  [isNewRequest]="isNewRequest"
  [destinations]="destinations"
  [trailerTypes]="trailerTypes"
  [sortTypes]="sortTypes"
  [serviceLevels]="serviceLevels"
  (onDestinationChange)="onDestinationChange($event)"
  (onDestinationSortChange)="onSortChange($event)"
  (fieldChange)="onFieldChange($event)">
</realign-request-form>
}

@if (model && model.requestType) {
<div class="row pt-3 ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-11 ps-md-0">
    {{localize(langSection.Legal, langText.TermsNotice1)}}
    <a href="{{localize(langSection.Legal, langText.TermsAndConditionsUrl)}}" target="_blank" rel="noopener"> {{localize(langSection.Legal, langText.TermsNotice2)}} </a>
    {{localize(langSection.Legal, langText.TermsNotice3)}}
    <a href="{{localize(langSection.Legal, langText.TechnologyAgreementUrl)}}" target="_blank" rel="noopener"> {{localize(langSection.Legal, langText.TermsNotice4)}} </a>
    {{localize(langSection.Legal, langText.TermsNotice5)}}
  </div>
</div>
}

@if (model && model.requestType) {
<div class="row pt-3 ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-11 ps-md-0">
    <button class="py-2 px-5 border-0 bg-green me-4 round-button submitButton" [disabled]="submitting || (!isNewRequest && !isDirty)" (click)="submit();">{{localize(langSection.Term, langText.Submit)}}</button>
    <button class="btn btn-link" (click)="onCancelClick()">{{localize(langSection.Term, langText.Cancel)}}</button>
  </div>
</div>
}

@if (model && model.requestType && hasValidationErrors) {
<div class="submit-failure">
  <span class="text-danger">{{localize(langSection.RequestFormPage, langText.InvalidFieldNotification)}}</span>
</div>
}

@if (model && model.requestType && receivedBadResponse) {
<div class="submit-failure">
  <span class="text-danger">{{localize(langSection.RequestFormPage, langText.ServerFailureNotification)}}</span>
</div>
}